module.exports = __webpack_public_path__ + "img/16.249be3f0.jpg";